import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  isDefault: boolean;
  onRemoveFromDefault: () => void;
  onSetAsDefault: () => void;
}

export default function EmployeesGroupActionsTableMenu({
  isDefault,
  onRemoveFromDefault,
  onSetAsDefault,
}: Props) {
  const { t } = useTranslation(['employeesGroups', 'common']);

  const permissions = usePermissions();

  const actions: Action[] = [
    ...(isDefault
      ? [
          {
            id: 'removeFromDefault',
            label: t('employeesGroups:common.table.actions.removeFromDefault'),
            onClick: onRemoveFromDefault,
            disabled: permissions.cannot(
              'removeFromDefault',
              'EmployeesGroups',
            ),
            tooltip: t('common:notSufficientPermissions'),
          },
        ]
      : [
          {
            id: 'setAsDefault',
            label: t('employeesGroups:common.table.actions.setAsDefault'),
            onClick: onSetAsDefault,
            disabled: permissions.cannot('setAsDefault', 'EmployeesGroups'),
            tooltip: t('common:notSufficientPermissions'),
          },
        ]),
  ];

  return <ActionsTableMenu actions={actions} />;
}
